import { render, staticRenderFns } from "./EditReceiptNumber.vue?vue&type=template&id=117d2073&scoped=true&"
import script from "./EditReceiptNumber.vue?vue&type=script&lang=js&"
export * from "./EditReceiptNumber.vue?vue&type=script&lang=js&"
import style0 from "./EditReceiptNumber.vue?vue&type=style&index=0&id=117d2073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117d2073",
  null
  
)

export default component.exports